// extracted by mini-css-extract-plugin
module.exports = {"component_language":"LanguageSwitch_component_language__CTgb_","language_item":"LanguageSwitch_language_item__IsOw_"};